<template>
    <div class="image-modal" v-if="isShow"> 
        <div class="image-modal__box">
            <img 
                class="image-modal__close"
                src="@/assets/images/close.svg" 
                width="24px" 
                alt=""
                @click="closeModal"
            >

            <img class="image-modal__content" :src="src" alt="">
        </div> 
     </div>
</template>

<script>
import {mapGetters, mapMutations} from 'vuex';

export default {
    computed: {
        ...mapGetters({
            isShow: 'imageModal/isShow',
            src: 'imageModal/src'
        })
    },
    methods: {
        ...mapMutations({
            setState: 'imageModal/setState'
        }),
        closeModal() {
            this.setState({
                key: 'isShow',
                value: false
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.image-modal {
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.7); 
    z-index: 5;
    display: flex;
    align-items: center;
    justify-content: center;
    animation: show .3s ease-out;

    &__box {
        position: relative;
        z-index: 6;
        height: auto;
        max-height: 90vh; 
        background-color: #fff;
        padding: 20px;
    }

    &__content {
        height: auto;
        max-height: 90vh;
        max-width: 80vw;
    }

    &__close {
        position: absolute;
        right: -26px;
        top: -26px;
        cursor: pointer;
    }
}

@keyframes show {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}
</style>